import type { ChangeEventHandler } from 'react';
import { useState } from 'react';

import type { SubmitHandler } from 'react-hook-form';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { NextType } from '../routes/Register.route';
import { apiCall } from '../utils/apiCall';

interface AvatarFileType {
    avatar: FileList;
}
const SetAvatar = ({ next }: NextType) => {
    const { t } = useTranslation();
    const [error, setError] = useState<null | string>(null);

    const { handleSubmit, register } = useForm<AvatarFileType>();

    const { onChange: registerOnChange, ...registerMethodsWithoutOnChange } = register('avatar');
    const onSubmit: SubmitHandler<AvatarFileType> = async ({ avatar }) => {
        if (avatar.length === 0) {
            setError(t('users.registration.AVATAR.AVATAR_EMPTY_FILE_ERROR'));
            return;
        }
        try {
            const response = await apiCall({
                body: avatar[0],
            });
            if (response.status === 200) {
                const body = await response.json();
                if (body.success) {
                    next();
                    return;
                }

                setError('unknown');
            }
        } catch (err) {
            if (err instanceof Error && err.message.includes('404')) {
                const error404 = t('errorPage.error');
                setError(error404);
                throw err;
            }
        }
    };
    const handleChange: ChangeEventHandler<HTMLInputElement> = async (event) => {
        if (error) {
            setError(null);
        }
        await registerOnChange(event);
    };
    return (
        <div className="flex items-center justify-center w-full min-h-screen p-4">
            <div className="w-full max-w-[420px] p-4 mx-auto bg-grey-light">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <p className="mb-4 text-3xl font-bold text-center text-blue">
                        {t('users.registration.AVATAR.AVATAR_PLACEHOLDER')}
                    </p>
                    <input
                        type="file"
                        {...registerMethodsWithoutOnChange}
                        data-testid="avatar-input"
                        onChange={handleChange}
                    />
                    {error && <div className="text-red-500">{error}</div>}

                    <input
                        className="text-xs font-semibold bg-blue py-2 px-3.5 text-white mt-4 block m-auto w-[30%]"
                        type="submit"
                        value={t('users.registration.SUBMIT_STEP')}
                        data-testid="submit-button"
                    />
                </form>
            </div>
        </div>
    );
};

export default SetAvatar;
